exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-681a67a1]{font-size:24px;font-weight:700;padding:20px;border-bottom:thin solid #ccc}.subtitle[data-v-681a67a1]{font-size:20px;font-weight:700}.parent-box[data-v-681a67a1]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;padding:40px}.box-request[data-v-681a67a1]{width:100%;height:auto;padding:20px;font-size:15px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-681a67a1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/ModalRequestHelp.vue
// module id = RoiD
// module chunks = 3